/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import {Button} from "@blueprintjs/core";
import {Intent} from "@blueprintjs/core/lib/esm/index";
import {IconNames} from "@blueprintjs/icons";
import {WrcForm} from "./WrcForm.js"

export class WrcFormOpener extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            canOutsideClickClose: false,
            is_loaded: false,
        };
    }

    showForm() {
        ReactDOM.render(
            <WrcForm
                    form_id={this.props.form_id}
                    refresh={this.state.refresh}
                    component_index={this.props.component_index}
                    configure_component={this.props.configure_component} />,
            document.querySelector('#form'));
    }

    componentDidMount() {
        this.setState({
            is_loaded: true,
            refresh: this.props.refresh});
    }

    render() {
        if (this.state.is_loaded) {
            return (
                <div className="wd-record">
                    <Button icon={IconNames.NEW_PERSON}
                            intent={Intent.PRIMARY}
                            text={this.props.button_text}
                            style={{marginTop: '1em'}}
                            fill={false}
                            onClick={() => this.showForm()} />
                </div>
            );
        }
        else {
            return (<div>Loading...</div>);
        }
    }
}


WrcFormOpener.propTypes = {
    form_id: PropTypes.number.isRequired,
    button_text: PropTypes.string.isRequired,
    refresh: PropTypes.func
};